import React from "react"
import styles from './whiteboard.module.css';
import { useNavigate } from "react-router-dom"

type Props = {}

export const WhiteboardMenu = (props: Props) => {

  const navigate = useNavigate();

  const naviageToGames = ()=>{
    navigate("/whiteboard");
  }

  return (
    <div className={"cursor-pointer " + styles.menuItem} onClick={naviageToGames}>
      <div className={"d-flex justify-content-center mt-3"}>
        <i className="fas fa-chalkboard  font-size-20"></i>
      </div>
      <div className={"d-flex justify-content-center font-size-12"}>
        Whiteboard
      </div>
    </div>
  )
}